import { SanityButtonProps, SanityImage } from '~/types'
import { Button, Heading } from '~/components'

interface BlockHeroBannerProps {
  type?: 'video' | 'image'
  button: SanityButtonProps
  images?: {
    image: SanityImage
    mobileImage: SanityImage
  }
  videos?: {
    video: SanityImage
    mobileVideo: SanityImage
  }
  title: string
  calloutTitles: string[]
}

// Main component
export default function BlockHeroBanner({
  type,
  button,
  images,
  videos,
  title,
  calloutTitles,
}: BlockHeroBannerProps) {
  return (
    <div className="ld:h-full relative flex h-dvh max-h-dvh w-full flex-col items-center justify-center lg:aspect-video">
      <div className="absolute inset-0 z-0 after:absolute after:inset-0 after:left-0 after:top-0 after:z-0 after:size-full after:bg-teal-800/40">
        {type == 'video' ? (
          videos &&
          videos.video && (
            <video
              autoPlay
              loop
              muted
              playsInline
              className="h-full w-dvw object-cover object-center lg:aspect-video"
            >
              {videos?.mobileVideo && (
                <source
                  src={videos?.mobileVideo?.asset?.url}
                  media="(max-width: 767px)"
                />
              )}
              <source src={videos?.video?.asset?.url} />
            </video>
          )
        ) : type == 'image' ? (
          <div className="h-full w-full">
            <img
              className="block size-full object-cover object-center lg:hidden"
              src={images?.mobileImage?.asset?.url}
              alt={images?.mobileImage?.alt}
            />
            <img
              className="hidden size-full object-cover object-center lg:block"
              src={images?.image?.asset?.url}
              alt={images?.image?.alt}
            />
          </div>
        ) : null}
      </div>
      <div className="container z-10 flex h-full flex-col items-center justify-between gap-24">
        <div></div>
        <div>
          {title && (
            <Heading
              size="h1"
              tag="h1"
              bold={false}
              className="mb-6 text-balance text-center text-beige-200"
            >
              {title}
            </Heading>
          )}
          <div className="flex justify-center">
            {button && (
              <Button
                size="text-base"
                {...button}
              />
            )}
          </div>
        </div>
        {calloutTitles ? (
          <div className="mb-6 flex flex-wrap justify-center gap-2 xl:gap-6">
            {calloutTitles.map((title, i) => (
              <Heading
                key={i}
                size="h3"
                tag="h2"
                bold={false}
                className="mb-0 text-center text-beige-200"
              >
                {title}
                {i < calloutTitles.length - 1 && (
                  <span className="ml-2 xl:ml-6">|</span>
                )}
              </Heading>
            ))}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  )
}
